exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.time-box[data-v-6d017ca2] {\n  margin: 10px 0;\n  background-color: #efefef;\n}\n.basic[data-v-6d017ca2] {\n  padding: 30px 0;\n  text-align: center;\n}\n.basic span[data-v-6d017ca2] {\n    color: #ff5000;\n    font-size: 22px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-6d017ca2","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/popularize/brokerageLog.vue
// module id = 1567
// module chunks = 0